<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "ProductionParent"
}
</script>

<style scoped>

</style>
